<template>
  <div class="previewContainer">
    <el-row type="flex" align="middle" justify="middle" class="preview-empty">
      <el-col class="pdfDivStyle" :span="24">
        <video-preview v-if="fileType >= 91 && fileType <= 120" :from-pc-preview="1" :id="parseInt(id)" :preview-url="previewUrl"></video-preview>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VideoPreview from "./VideoPreview";

export default {
  data() {
    return {
      id: this.$route.query.fileId,
      authorization: this.$route.query.authorization,
      fileType: 0,
      previewUrl: '',
    }
  },
  components: {
    VideoPreview,
  },
  mounted() {
    //设置登录信息
    if(this.authorization && typeof this.authorization != 'undefined') {
      localStorage.setItem('rs_t', this.authorization);
    }
    this.checkPreviewFile();
  },
  methods: {
    checkPreviewFile(){
      let vm = this;
      vm.ucloading.showLoading();
      this.$api.get("/resapi/pc/resource-file/checkPreviewFile", {params: {id: vm.id}}).then(res => {
        vm.ucloading.hideLoading()
        if(!res.success){
          return vm.$message.error(res.info);
        }
        this.fileType = res.data.fileType;
        this.previewUrl = res.data.previewUrl||'';
      }).catch(res => {
        vm.ucloading.hideLoading()
        console.log(res)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.previewContainer{
  text-align: center;
  height: 100%;

  .pdfDivStyle{
     height: 100%;
  }
}
</style>